import { render, staticRenderFns } from "./keterangan-kerja.vue?vue&type=template&id=6cda063c&"
import script from "./keterangan-kerja.vue?vue&type=script&lang=js&"
export * from "./keterangan-kerja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports